import { render, staticRenderFns } from "./ErrorHandler.vue?vue&type=template&id=f022881a&scoped=true"
import script from "./ErrorHandler.vue?vue&type=script&lang=ts"
export * from "./ErrorHandler.vue?vue&type=script&lang=ts"
import style0 from "./ErrorHandler.vue?vue&type=style&index=0&id=f022881a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f022881a",
  null
  
)

export default component.exports